import React from 'react';
import '../styles/marquee.css';

const phrases = [
  'Decentralized trading systems',
  'Risk management',
  'White-label solutions',
  'Central Limit Order Book',
  'Financial engineering',
  'Smart contract infrastructure',
  'Derivative pricing',
  'Perpetual futures',
  'Automated market making',
  'Leveraged prediction markets'
];

function Marquee() {
  const content = phrases.map((p) => `  ·  ${p}`).join('');
  const doubled = content + content;

  return (
    <div className="marquee">
      <div className="marquee-track">
        <span className="marquee-text">{doubled}</span>
      </div>
    </div>
  );
}

export default Marquee;
